import * as tslib_1 from "tslib";
import { Button, Card, DatePicker, Form, Input, message } from 'antd';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import MBraftEditor from './MBraftEditor';
import BraftEditor from 'braft-editor';
import { addNotice, updateNotice } from '@/services/menu';
import moment from 'moment';
import { dispatch } from '@@/store';
const Root = styled(Card) ``;
const FORM_ITEM_LAYOUT = {
    labelCol: { span: 4 },
    wrapperCol: { span: 18 },
};
const CreateOrEditCarousel = ({ className, style, currentRoute, currentRoute: { query }, form, form: { getFieldDecorator, validateFields }, }) => {
    useEffect(() => {
        if (query.id) {
            const record = JSON.parse(localStorage.getItem('curEditCarousel') || '');
            let content = BraftEditor.createEditorState(record.content);
            form.setFieldsValue({
                content,
                name: record.name,
                displayDate: [
                    moment(record.noticeStartDate),
                    moment(record.noticeExpireDate),
                ],
            });
        }
    }, []);
    const onSubmitForm = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        const values = yield new Promise((resolve, reject) => {
            validateFields((errs, values) => {
                if (errs)
                    return reject(errs);
                resolve(values);
            });
        });
        values.content = values.content.toHTML();
        console.log('values', values);
        if (query.id) {
            updateNotice({
                id: query.id,
                name: values.name,
                content: values.content,
                noticeStartDate: values.displayDate[0],
                noticeExpireDate: values.displayDate[1],
            }).promise.then((res) => {
                message.info('修改成功');
                dispatch.router.push(`/deployCarousel`);
            });
        }
        else {
            addNotice({
                name: values.name,
                content: values.content,
                noticeStartDate: values.displayDate[0],
                noticeExpireDate: values.displayDate[1],
            }).promise.then((res) => {
                message.info('添加成功！');
                dispatch.router.push(`/deployCarousel`);
            });
        }
    });
    return (<Root className={className} style={style}>
      <Form>
        <Form.Item label="公告名称" {...FORM_ITEM_LAYOUT}>
          {getFieldDecorator('name', {
        rules: [{ required: true }],
    })(<Input />)}
        </Form.Item>
        <Form.Item label="展示时间" {...FORM_ITEM_LAYOUT}>
          {getFieldDecorator('displayDate', {
        rules: [{ required: true }],
    })(<DatePicker.RangePicker />)}
        </Form.Item>
        <Form.Item label="公告内容" {...FORM_ITEM_LAYOUT}>
          {getFieldDecorator('content', {
        rules: [
            {
                required: true,
                validator: (_, value, callback) => {
                    if (value.isEmpty()) {
                        callback('请输入公告内容');
                    }
                    else if (value.toHTML().length > 5000) {
                        callback('太长了');
                    }
                    else {
                        callback();
                    }
                },
            },
        ],
    })(<MBraftEditor />)}
        </Form.Item>

        <Button style={{ marginLeft: '30%' }} type="primary" onClick={onSubmitForm}>
          提交
        </Button>
      </Form>
    </Root>);
};
export default Form.create()(CreateOrEditCarousel);
